import { render, staticRenderFns } from "./hotkey.component.vue?vue&type=template&id=3ffc99a8&scoped=true"
import script from "./hotkey.component.vue?vue&type=script&lang=js"
export * from "./hotkey.component.vue?vue&type=script&lang=js"
import style0 from "./hotkey.component.vue?vue&type=style&index=0&id=3ffc99a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc99a8",
  null
  
)

export default component.exports